<template>
  <el-form class="serach-form" :inline="true" :model="filters" size="small">
    <el-row>
      <el-form-item
        class="select_btn_160"
        v-if="activeTab == '1' || activeTab == '4'"
      >
        <el-select
          class="select_btn_style"
          v-model="filters.displayClientList"
          placeholder="展示终端"
          multiple
          collapse-tags
        >
          <el-option
            v-for="(item, i) in displayTypeList"
            :key="i"
            :label="item.paramValue"
            :value="item.paramKey"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item class="m-l-14">
        <el-input
          clearable
          prefix-icon="el-icon-search"
          size="small"
          v-model="filters.name"
          placeholder="资源名称"
        ></el-input>
      </el-form-item>
      <el-form-item class="m-l-14">
        <load-select
          style="width: 530px"
          v-model="filters.classId"
          dictLabel="className"
          dictValue="uuid"
          :data="classList"
          :page="pageClass"
          :hasMore="moreClass"
          :request="getClassPage"
          @ChangeValue="changeClass"
          :isInit="isClassInit"
          :defaultVal="filters.className"
          placeholder="请选择线上班级（输入班级名称关键字以查询）"
        />
      </el-form-item>
      <el-form-item class="m-l-14">
        <butn btntype="primary" title="查询" @click="initData"></butn>
        <butn title="重置" @click="resetData" class="czButn"></butn>
      </el-form-item>
    </el-row>
  </el-form>
</template>

<script>
import butn from "@/components/button/index";
import LoadSelect from "@/components/load-select/index.vue";
import {getOnlineClass} from "@/api/class.js"
export default {
  props: {
    activeTab: {
      type: String,
      default: "",
    },
    displayTypeList: {
      type: Array,
      default: () => [],
    },
  },
  components: { butn, LoadSelect },
  data() {
    return {
      filters: {},

      isClassInit: true,
      classList: [],
      pageClass: 1,
      moreClass: true,
    };
  },
  created() {},
  methods: {
    initData() {
      // if (this.filters.displayClientTypes.includes("")) {
      //   delete this.filters.displayClientTypes;
      // }
      let params = { ...this.filters };
      params.page = 1;
      delete params.className;
      this.$emit("search", params);
    },
    resetData() {
      this.filters = {};
      this.$emit("search", {});
    },

    getClassPage({ page = 1, more = false, keyword = "" } = {}) {
      return new Promise((resolve, reject) => {
        getOnlineClass({
          page,
          className: keyword,
        })
          .then(({ code, data }) => {
            this.dealClass(more, code, data);
            resolve();
          })
          .catch((error) => {
            reject(error);
          });
      });
    },

    dealClass(more, code, data) {
      if (code !== 0) return;
      if (more) {
        this.classList = [...this.classList, ...data.records];
      } else {
        this.classList = data.records;
      }
      this.pageClass = data.current;
      let { current, total, size } = data;
      this.moreClass = current * size < total;
      this.pageClass = current;
    },

    changeClass(val) {
      if (!!val) {
        let item = this.classList.filter((item) => item.uuid == val)[0];
        this.filters.className = item.className;
      } else {
        this.filters.className = "";
      }
    },
  },
};
</script>

<style lang="scss" scoped>
$color: #d7dbe0;
$border-radius: 2px;
.serach-form {
  text-align: left;
  border-bottom: 1px dashed #ebeef5;
  margin-bottom: 20px;
  & /deep/ .none-margin-right {
    margin-right: 0;
  }
  .name-input {
    width: 250px;
    margin-right: 10px;
  }
}
</style>
